import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

const dateSort = (dateA, dateB) =>
  dayjs(dateA, "YYYY-MM-DD") - dayjs(dateB, "YYYY-MM-DD");

const timeSort = (timeA, timeB) =>
  dayjs(timeA, "h:mmA").format("X") - dayjs(timeB, "h:mmA").format("X");

const defaultSort = (a, b) => {
  if (a < b) return -1;
  if (b < a) return 1;
  return 0;
};

export const Sorter = {
  DEFAULT: defaultSort,
  DATE: dateSort,
  TIME: timeSort,
};
